import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const { fields } = block

  if (!fields.files) {
    return true
  }

  if (!fields.files.length) {
    return true
  }

  return false
}
